import React from 'react';

const Datenschutz = () => {
    return (
        <div className="container mx-auto px-4 py-8 max-w-4xl">
            <h1 className="text-3xl font-bold mb-6 text-gray-900 dark:text-gray-100">Datenschutzerklärung</h1>

            <div className="bg-white dark:bg-[#1e1e1e] p-6 rounded-xl shadow-sm border border-gray-200 dark:border-gray-800 space-y-6">
                <section>
                    <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">1. Datenschutz auf einen Blick</h2>
                    <h3 className="font-medium mb-1 text-gray-700 dark:text-gray-300">Allgemeine Hinweise</h3>
                    <p className="text-gray-600 dark:text-gray-400 mb-2">
                        Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                    </p>
                    <h3 className="font-medium mb-1 text-gray-700 dark:text-gray-300">Datenerfassung auf dieser Website</h3>
                    <p className="text-gray-600 dark:text-gray-400">
                        <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                        Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">2. Hosting</h2>
                    <p className="text-gray-600 dark:text-gray-400">
                        Wir hosten die Inhalte unserer Website bei folgendem Anbieter:<br />
                        Contabo GmbH, Aschauer Straße 32a, 81549 München, Deutschland.
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">3. Allgemeine Hinweise und Pflichtinformationen</h2>
                    <h3 className="font-medium mb-1 text-gray-700 dark:text-gray-300">Datenschutz</h3>
                    <p className="text-gray-600 dark:text-gray-400 mb-2">
                        Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                    </p>
                    <h3 className="font-medium mb-1 text-gray-700 dark:text-gray-300">Hinweis zur verantwortlichen Stelle</h3>
                    <p className="text-gray-600 dark:text-gray-400">
                        Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br />
                        Felix Brabetz<br />
                        E-Mail: felix.brabetz@plantlix.de
                    </p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold mb-2 text-gray-800 dark:text-gray-200">4. Datenerfassung auf dieser Website</h2>
                    <h3 className="font-medium mb-1 text-gray-700 dark:text-gray-300">Cookies</h3>
                    <p className="text-gray-600 dark:text-gray-400">
                        Unsere Internetseiten verwenden so genannte „Cookies“. Cookies sind kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an. Sie dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.
                    </p>
                </section>

                <p className="text-xs text-gray-400 mt-8">
                    Quelle: <a href="https://www.e-recht24.de" target="_blank" rel="noopener noreferrer" className="hover:underline">e-recht24.de</a>
                </p>
            </div>
        </div>
    );
};

export default Datenschutz;
